import { func, string } from 'prop-types'
import { useMapEvent } from 'react-leaflet'
import { latLngToPosizione } from './utilMappa'

BaseMappaEvento.propTypes = {
  on: string.isRequired,
  handler: func.isRequired,
}

export default function BaseMappaEvento(props) {
  const { on, handler } = props
  
  const map = useMapEvent(on, event => {
    const { latlng } = event
    handler({
      ...(latlng && { posizione: latLngToPosizione(latlng) }),
      // In base a necessità future passerò altre proprietà dell'evento
      // e delle funzioni custom che usano map per manipolare la mappa
    })
  })

  return null
}